import React, { useState } from "react"
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai"
import { Link } from "react-router-dom";
import old_school_logo from "../Assets/old_school_logo.png";

const Navbar = () => {

    const [nav, setNav] = useState(false);

    const handleNav = () => {
        setNav(!nav)
    }

    const handleLinkClick = (sectionId) => {
        setNav(!nav); // Close the navbar
        if (sectionId) {
            document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
        }
    };

    const navLinks = [
        { to: "/", label: "Home" },
        { to: "/aboutp", label: "About us" },
        { to: "/allcoursesp", label: "All courses" },
        { to: "/admissionp", label: "Admission" },
        { to: "/contactp", label: "Contact" },
    ];

    return (
        <div
            className="fixed top-0 left-0 right-0 z-50 flex justify-between items-center py-3 px-4 md:px-10 lg:px-16 bg-white border-b border-[#12213D]/10"
            style={{ fontFamily: "'Inter', sans-serif" }}
        >
            <Link to="/" className="shrink-0">
                <img className="w-16 md:w-20" src={old_school_logo} alt="School logo" />
            </Link>

            <ul className="hidden md:flex items-center mx-auto gap-1">
                {navLinks.map((link) => (
                    <li key={link.label}>
                        <Link
                            to={link.to}
                            className="relative px-4 py-2 text-[#12213D] text-sm inline-block after:content-[''] after:absolute after:left-4 after:right-4 after:-bottom-0.5 after:h-[1.5px] after:bg-[#B8862E] after:scale-x-0 after:origin-left after:transition-transform hover:after:scale-x-100"
                        >
                            {link.label}
                        </Link>
                    </li>
                ))}
            </ul>

            <div className="flex items-center gap-3">
                <Link to="https://www.portalocohstech.com/">
                    <button className="flex items-center gap-1.5 px-4 py-2.5 bg-[#925FE2] hover:bg-[#7f4fd1] rounded-lg text-white text-sm font-medium transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <span>Sign in</span>
                    </button>
                </Link>

                <button
                    onClick={handleNav}
                    className="md:hidden p-1.5 text-[#12213D]"
                    aria-label="Toggle menu"
                >
                    {nav ? <AiOutlineClose size={22} /> : <AiOutlineMenu size={22} />}
                </button>
            </div>

            {/* Mobile slide-in menu */}
            <div
                className={`fixed top-0 h-full w-[85%] max-w-xs bg-white border-r border-[#12213D]/10 shadow-[0_0_40px_rgba(18,33,61,0.12)] transition-[left] duration-500 ease-out ${
                    nav ? "left-0" : "left-[-110%]"
                }`}
            >
                <div className="flex items-center px-5 pt-6 pb-4 border-b border-[#12213D]/10">
                    <img className="w-16" src={old_school_logo} alt="School logo" />
                </div>

                <ul className="flex flex-col py-4">
                    {navLinks.map((link) => (
                        <li
                            key={link.label}
                            className="border-l-2 border-transparent hover:border-[#B8862E]"
                            onClick={() => handleLinkClick()}
                        >
                            <Link to={link.to} className="block px-6 py-3 text-[#12213D] text-base">
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>

                <div className="px-6 mt-4">
                    <Link to="https://www.portalocohstech.com/">
                        <button className="w-full flex items-center justify-center gap-1.5 px-4 py-3 bg-[#925FE2] hover:bg-[#7f4fd1] rounded-lg text-white text-sm font-medium transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                            <span>Sign in</span>
                        </button>
                    </Link>
                </div>
            </div>

            {/* Backdrop for mobile menu */}
            {nav && (
                <div
                    onClick={handleNav}
                    className="fixed inset-0 -z-10 bg-[#12213D]/20 md:hidden"
                />
            )}
        </div>
    );
}

export default Navbar;